import React from 'react';
import { useNavigate } from 'react-router-dom';

import s1_1 from '../../../assets/images/ms1_img1.png';
import s1_2 from '../../../assets/images/ms1_img2.png';
import s1_3 from '../../../assets/images/ms1_img3.png';
import s1_4 from '../../../assets/images/ms1_img4.png';

import right_arrow from '../../../assets/images/right_arrow.png';

export default function Section1() {
  
  return (
    <div className="center">
      <div className="sect1 pt-10 pb-7">
        <div className="s1_header w-100 row-flex between align-end  mb-3">
          <div className="col-flex txt-left gap-20">
            <p className="prt-medium fs-20 fc-005eed">제품소개</p>
            <p className="prt-bold fs-50 fc-black1 lh-13">
              키논로보틱스의 <br />
              기술력을 만나보세요
            </p>
          </div>
          <div className="prt-medium fs-20 fc-black1 row-flex-center gap-10">
            <a href="/sub2_1_1">더보기</a>
            <img src={right_arrow} alt="" />
          </div>
        </div>

        <div
          className="sect1_boxes_container 
        row-flex-center between m-flex-wrap"
        >
          <div
            onClick={() => (window.location.href = '/sub2_1_1')}
            className="sect1_box relative 
            of-hidden pointer m-w-48"
            style={{ backgroundImage: `url(${s1_1})` }}
          >
            <div className="sect1_box_content col-flex">
              <div className="sect1_box_title prt-medium fs-28 fc-white mb-3">
                서빙로봇
              </div>
              <div className="sect1_box_description prt-light fs-18 fc-white lh-15">
                자연스럽고 정확한 상호작용으로
                <br /> 더 특별한 서비스를 제공합니다.
              </div>
              <div className="sect1_box_button prt-medium fs-14 fc-white">
                자세히 보기
              </div>
            </div>
          </div>

          <div
            onClick={() => (window.location.href = '/sub2_3_1')}
            className="sect1_box m-w-48"
            style={{ backgroundImage: `url(${s1_2})` }}
          >
            <div className="sect1_box_content col-flex">
              <div className="sect1_box_title prt-medium fs-28 fc-white mb-3">
                청소로봇
              </div>
              <div className="sect1_box_description prt-light fs-18 fc-white lh-15">
                다용도 청소 솔루션으로
                <br />
                넓은 공간도 깔끔하게 청소합니다.
              </div>
              <div className="sect1_box_button prt-medium fs-14 fc-white">
                자세히 보기
              </div>
            </div>
          </div>

          <div
            onClick={() => (window.location.href = '/sub2_1_7')}
            className="sect1_box m-w-48"
            style={{ backgroundImage: `url(${s1_3})` }}
          >
            <div className="sect1_box_content col-flex">
              <div className="sect1_box_title prt-medium fs-28 fc-white mb-3">
                호텔로봇
              </div>
              <div className="sect1_box_description prt-light fs-18 fc-white lh-15">
                안전하고 위생적인 도어 밀폐식 디자인으로
                <br />한 번에 최대 4개층 멀티플 서빙이 가능합니다.
              </div>
              <div className="sect1_box_button prt-medium fs-14 fc-white">
                자세히 보기
              </div>
            </div>
          </div>

          <div
            onClick={() => (window.location.href = '/sub2_2')}
            className="sect1_box m-w-48"
            style={{ backgroundImage: `url(${s1_4})` }}
          >
            <div className="sect1_box_content col-flex">
              <div className="sect1_box_title prt-medium fs-28 fc-white mb-3">
                물류로봇
              </div>
              <div className="sect1_box_description prt-light fs-18 fc-white lh-15">
                인건비 부담을 줄여주는 물류로봇으로 <br /> 매장 효율을 높일 수
                있습니다.
              </div>
              <div className="sect1_box_button prt-medium fs-14 fc-white">
                자세히 보기
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
